import React from 'react';
import Admin from './Admin'; // We will use the Admin component as the root

function App() {
  return <Admin />;
}

export default App;
